/**
 * TagList React component
 * 
 * @author    Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


import React from 'react';
import PropTypes from 'prop-types';
import Tag from "./Tag";
import AutosuggestField from "./AutosuggestField";


/**
 * A TagList is a React component for displaying multiple tags and a autocomplete field for adding tags if it is editable
 *
 * @author Maurizio Tidei
 */
export default class TagList extends React.Component {


    render() {

        // TODO Style add tag field to fit the tags
        return (
            <div>
                {this.props.tags && this.props.tags.map((tag, i) => {

                    return <Tag key={i} label={tag}
                                onDelete={this.props.onDelete ? () => this.props.onDelete(i) : undefined}
                                onClick={this.props.onTagClick ? () => this.props.onTagClick(tag) : undefined}/>;
                })}
                {this.props.onAdd && <span style={{marginLeft:"5px"}}><AutosuggestField placeholder="Add Tag..." onEnterKey={this.props.onAdd} suggestions={this.props.suggestions}/></span>}
            </div>
        );
    }
}


TagList.propTypes = {
    tags: PropTypes.array.isRequired,
    autocompleteStrings: PropTypes.array,
    onDelete: PropTypes.func,
    onAdd: PropTypes.func,
    onTagClick: PropTypes.func,
    suggestions: PropTypes.array
};


